<nav [ngClass]="{ 'spinner white': isLoading() }">
  <p-panelMenu [model]="getItems()" [multiple]="true"></p-panelMenu>
</nav>
